"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TotalAmount = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../../../../utils");
var _ui = require("../../../../ui");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var PrimaryAmountWithEquivalentWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 20px 0;\n  ", "\n"])), _utils.mediaQuery.lessThan('sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 16px: 0;\n  "]))));
var TotalAmount = function TotalAmount(_ref) {
  var amount = _ref.amount,
    ticker = _ref.ticker,
    convertedAmount = _ref.convertedAmount,
    convertedTicker = _ref.convertedTicker,
    className = _ref.className;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_ui.SeparativeLine, null), /*#__PURE__*/_react.default.createElement(PrimaryAmountWithEquivalentWrapper, {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(_ui.H3, {
    className: "mb-0 me-2"
  }, t('total'), ":"), /*#__PURE__*/_react.default.createElement(_ui.PrimaryAmountWithEquivalent, {
    component: _ui.H3,
    amount: amount,
    ticker: ticker,
    convertedTicker: convertedTicker,
    convertedAmount: convertedAmount,
    className: "mb-0"
  })), /*#__PURE__*/_react.default.createElement(_ui.SeparativeLine, null));
};
exports.TotalAmount = TotalAmount;